import React from 'react';
import classes from './educationitem.module.css';

const EducationItem = (props) => {
    return (
        <div className={ classes.item }>
            <ul>
                <li>{props.school}</li>
                <p>{props.major}</p>
            </ul>
            
        </div>
    );
}

export default EducationItem;